export default __webpack_public_path__ + "static/media/TF_09.42ba6fea.png";